<script setup lang="ts">
import {
  type DropdownMenuContentProps,
  DropdownMenuContent,
  DropdownMenuPortal,
} from "reka-ui"

defineOptions({
  inheritAttrs: false,
})

const { sideOffset = 4 } = defineProps<{
  align?: DropdownMenuContentProps["align"]
  side?: DropdownMenuContentProps["side"]
  sideOffset?: DropdownMenuContentProps["sideOffset"]
}>()
</script>

<template>
  <DropdownMenuPortal>
    <DropdownMenuContent
      :side
      :side-offset
      :align
      class="DropdownMenuContent z-50"
      v-bind="$attrs"
    >
      <div
        data-testid="dropdownmenu_options"
        class="flex flex-col overflow-hidden rounded-lg border border-zinc-300 bg-white transition-all"
      >
        <slot />
      </div>
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>

<style scoped>
:deep(.DropdownMenuContent) {
  min-width: var(--reka-dropdown-menu-trigger-width);
  animation: scaleIn 0.2s ease-out;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
